(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bookmarks-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Bookmarks stored in customer metafields via App Proxy
    const container = document.querySelector('.js-bookmarks-grid');
    if (!container) return;

    const emptyTemplate = document.getElementById('bookmarks-empty-template');
    const cardTemplate = document.getElementById('bookmark-card-template');
    const isLoggedIn = container.hasAttribute('data-customer-id');

    function getArticleSlug(handle) {
      if (!handle) return '';
      return handle.split('/').pop();
    }

    // Fetch bookmarks via App Proxy
    async function getBookmarks() {
      console.log('Fetching bookmarks from App Proxy...');
      try {
        const response = await fetch('/apps/bookmarks');
        console.log('Fetch response status:', response.status);
        if (!response.ok) {
          console.error('Fetch failed with status:', response.status);
          return [];
        }
        const data = await response.json();
        console.log('Fetched bookmarks:', data);
        return data.bookmarks || [];
      } catch (error) {
        console.error('Bookmark fetch failed:', error);
        return [];
      }
    }

    // Save bookmarks via App Proxy
    async function saveBookmarks(bookmarks) {
      console.log('Saving bookmarks:', bookmarks);
      try {
        const response = await fetch('/apps/bookmarks', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ bookmarks })
        });
        console.log('Save response status:', response.status);
        const data = await response.json();
        console.log('Save response data:', data);
        if (!response.ok) {
          console.error('Save failed with status:', response.status, data);
          return false;
        }
        return data.success === true;
      } catch (error) {
        console.error('Bookmark save failed:', error);
        return false;
      }
    }

    async function removeBookmark(articleHandle) {
      console.log('Removing bookmark:', articleHandle);
      let bookmarks = await getBookmarks();
      console.log('Current bookmarks before filter:', bookmarks);
      bookmarks = bookmarks.filter(b => {
        const handle = typeof b === 'string' ? b.split('/').pop() : b.handle;
        return handle !== articleHandle;
      });
      console.log('Bookmarks after filter:', bookmarks);

      const success = await saveBookmarks(bookmarks);
      console.log('Remove success:', success);
      if (success) {
        window.dispatchEvent(new CustomEvent('bookmarks:updated', {
          detail: { bookmarks, articleHandle, action: 'removed' }
        }));
        renderBookmarks();
      } else {
        console.error('Failed to remove bookmark');
      }
    }

    // Normalize bookmark data (handles both old string format and new object format)
    function normalizeBookmark(bookmark) {
      if (typeof bookmark === 'string') {
        // Old format: "blog/article-slug" or just "article-slug"
        const parts = bookmark.split('/');
        if (parts.length >= 2) {
          return {
            handle: parts[parts.length - 1],
            blogHandle: parts[parts.length - 2],
            title: parts[parts.length - 1].replace(/-/g, ' '),
            excerpt: '',
            image: '',
            url: `/blogs/${parts[parts.length - 2]}/${parts[parts.length - 1]}`
          };
        }
        return {
          handle: bookmark,
          blogHandle: '',
          title: bookmark.replace(/-/g, ' '),
          excerpt: '',
          image: '',
          url: ''
        };
      }
      // New format: object with all data
      return {
        handle: bookmark.handle || '',
        blogHandle: bookmark.blogHandle || '',
        title: bookmark.title || bookmark.handle?.replace(/-/g, ' ') || '',
        excerpt: bookmark.excerpt || '',
        image: bookmark.image || '',
        url: bookmark.url || `/blogs/${bookmark.blogHandle}/${bookmark.handle}`
      };
    }

    function truncateText(text, wordLimit) {
      if (!text) return '';
      const words = text.split(/\s+/);
      if (words.length <= wordLimit) return text;
      return words.slice(0, wordLimit).join(' ') + '...';
    }

    function stripHtml(html) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }

    function createArticleCard(article) {
      const clone = cardTemplate.content.cloneNode(true);
      const item = clone.querySelector('.bookmark-item');
      const card = clone.querySelector('.bookmark-card');

      const url = article.url || `/blogs/${article.blogHandle}/${article.handle}`;

      // Set article URLs on all links
      card.querySelectorAll('a').forEach(link => {
        link.href = url;
      });

      // Set title
      const titleLink = card.querySelector('.bookmark-card__title a');
      titleLink.textContent = article.title || article.handle;

      // Hide tag (not stored in bookmark data)
      const tagEl = card.querySelector('.bookmark-card__tag');
      if (tagEl) tagEl.style.display = 'none';

      // Set excerpt
      const excerptEl = card.querySelector('.bookmark-card__excerpt');
      if (excerptEl) {
        if (article.excerpt) {
          excerptEl.textContent = article.excerpt;
        } else {
          excerptEl.style.display = 'none';
        }
      }

      // Set image
      const imgContainer = card.querySelector('.bookmark-card__image');
      const img = card.querySelector('.bookmark-card__image img');
      if (article.image) {
        img.src = article.image;
        img.alt = article.title || '';
      } else {
        imgContainer.classList.add('bookmark-card__image--no-image');
      }

      // Set up remove button
      const removeBtn = card.querySelector('.bookmark-card__remove');
      removeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        removeBookmark(article.handle);
      });

      return item;
    }

    async function renderBookmarks() {
      // Check if user is logged in - if not, just clear container (login prompt handles the CTA)
      if (!isLoggedIn) {
        container.innerHTML = '';
        return;
      }

      // Show loading state
      container.innerHTML = '<div class="bookmarks-loading"><span class="visually-hidden">Loading...</span></div>';

      // Fetch bookmarks via App Proxy
      const bookmarks = await getBookmarks();
      console.log('Bookmarks:', bookmarks);

      if (bookmarks.length === 0) {
        container.innerHTML = '';
        container.appendChild(emptyTemplate.content.cloneNode(true));
        return;
      }

      // Normalize bookmark data (handles both old string format and new object format)
      const articles = bookmarks.map(b => normalizeBookmark(b)).filter(a => a.handle);
      console.log('Normalized articles:', articles);

      // Render cards
      container.innerHTML = '';

      if (articles.length === 0) {
        container.appendChild(emptyTemplate.content.cloneNode(true));
        return;
      }

      articles.forEach(article => {
        const card = createArticleCard(article);
        container.appendChild(card);
      });
    }

    // Initial render
    renderBookmarks();

    // Listen for bookmark updates from other components
    window.addEventListener('bookmarks:updated', renderBookmarks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var slideshow = document.querySelector('.hero__slideshow');
    if (!slideshow) return;

    var section = slideshow.closest('.hero__container');
    if (!section) return;

    var contentItems = section.querySelectorAll('.hero__bottom-left-content');
    var indicators = section.querySelectorAll('.hero__indicator');

    function syncContent(index) {
      contentItems.forEach(function(el, i) {
        el.classList.toggle('carousel-active', i === index);
      });
      indicators.forEach(function(el, i) {
        el.classList.toggle('indicator-active', i === index);
      });
    }

    // Set initial state
    syncContent(0);

    // Sync on slideshow slide change
    slideshow.addEventListener('slideshow:select', function(e) {
      syncContent(e.detail.index);
    });

    // Wire indicator clicks to slideshow
    indicators.forEach(function(btn) {
      btn.addEventListener('click', function(event) {
        var idx = parseInt(btn.dataset.index, 10);
        if (Number.isFinite(idx)) {
          slideshow.select(idx, event);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-listings"]) return;
  try {
    
  (function() {
    function showNotification(message) {
      const existing = document.querySelector('.bookmark-notification');
      if (existing) existing.remove();

      const notification = document.createElement('div');
      notification.className = 'bookmark-notification';
      notification.textContent = message;
      document.body.appendChild(notification);

      setTimeout(() => {
        notification.classList.add('bookmark-notification--hiding');
        setTimeout(() => notification.remove(), 300);
      }, 2500);
    }

    async function getBookmarks() {
      try {
        const response = await fetch('/apps/bookmarks');
        if (!response.ok) return [];
        const data = await response.json();
        return data.bookmarks || [];
      } catch (error) {
        console.error('Bookmark fetch failed:', error);
        return [];
      }
    }

    async function saveBookmarks(bookmarks) {
      try {
        const response = await fetch('/apps/bookmarks', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ bookmarks })
        });
        if (!response.ok) return false;
        const data = await response.json();
        return data.success === true;
      } catch (error) {
        console.error('Bookmark save failed:', error);
        return false;
      }
    }

    function initBookmarks() {
      document.querySelectorAll('[data-bookmark-button]').forEach(btn => {
        if (btn._bookmarkBound) return;
        btn._bookmarkBound = true;

        btn.addEventListener('click', async (e) => {
          e.preventDefault();

          if (btn.hasAttribute('data-require-login')) {
            window.location.href = '/account/login';
            return;
          }

          const articleHandle = btn.getAttribute('data-article-handle');
          const blogHandle = btn.getAttribute('data-blog-handle');
          if (!articleHandle || !blogHandle) return;

          const articleData = {
            handle: articleHandle,
            blogHandle: blogHandle,
            title: btn.getAttribute('data-article-title') || '',
            excerpt: btn.getAttribute('data-article-excerpt') || '',
            image: btn.getAttribute('data-article-image') || '',
            url: `/blogs/${blogHandle}/${articleHandle}`
          };

          btn.disabled = true;
          const isActive = btn.getAttribute('aria-pressed') === 'true';

          let bookmarks = await getBookmarks();

          if (isActive) {
            bookmarks = bookmarks.filter(b => {
              const h = typeof b === 'string' ? b : b.handle;
              return h !== articleHandle;
            });
            showNotification('Article removed from saved');
          } else {
            const exists = bookmarks.some(b => {
              const h = typeof b === 'string' ? b : b.handle;
              return h === articleHandle;
            });
            if (!exists) {
              bookmarks.push(articleData);
            }
            showNotification('Article saved');
          }

          const success = await saveBookmarks(bookmarks);

          if (success) {
            btn.setAttribute('aria-pressed', String(!isActive));
            btn.classList.toggle('blog-listing-card__bookmark--active', !isActive);
            window.dispatchEvent(new CustomEvent('bookmarks:updated', {
              detail: { bookmarks, articleHandle, action: isActive ? 'removed' : 'added' }
            }));
          } else {
            showNotification('Failed to save. Please try again.');
          }

          btn.disabled = false;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBookmarks);
    } else {
      initBookmarks();
    }

    document.addEventListener('shopify:section:load', initBookmarks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
